import React from 'react';
import { useTheme } from '@mui/material';
import AsyncCreatable from 'react-select/async-creatable';
import PropTypes from 'prop-types';

import useFuse from '../../hooks/useFuse';
import { customSelectStyles } from './Select';

const FuzzySelect = (props) => {
  const { options, fuzzyOptions, searchTextCleaner, ...rest } = props;

  const fuse = useFuse(options, fuzzyOptions);

  // search with promise
  const searchOptions = (inputValue) =>
    new Promise((resolve) => {
      if (!inputValue) return;

      resolve(fuse.search(inputValue).map((c) => ({ ...c.item })));
    });

  // call promise searchOptions
  const loadOptions = (searchTerm) => {
    const cleanedSearchTerm =
      typeof searchTextCleaner === 'function' ? searchTextCleaner(searchTerm) : searchTerm;

    return searchOptions(cleanedSearchTerm);
  };

  const theme = useTheme();

  const customStylesForSelect = customSelectStyles(theme);

  return (
    <AsyncCreatable
      styles={customStylesForSelect}
      defaultOptions={options}
      {...rest}
      loadOptions={loadOptions}
    />
  );
};

export default FuzzySelect;

FuzzySelect.propTypes = {
  searchTextCleaner: PropTypes.func,
  fuzzyOptions: PropTypes.shape({
    ignoreLocation: PropTypes.bool,
    includeScore: PropTypes.bool,
    keys: PropTypes.arrayOf(PropTypes.string),
    threshold: PropTypes.number,
    valueKey: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      labelWithoutAccents: PropTypes.string,
      value: PropTypes.string,
      isDentoloDentist: PropTypes.bool,
    })
  ),
};
